import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorMasterCategoryMajorView = () => {
  const { t } = useTranslation()

  const categoryMajorView = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/master-category/major-view', payload, response => {
        if (response.status_code === 200) {
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 1500,
            redirect: '/master/category-major/manage',
          })
        }
        loading(false)
      })
    },
    [t],
  )

  return { categoryMajorView }
}

export default InteractorMasterCategoryMajorView
